/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationstrustCommerceTrustCommerceIntegration model module.
 * @module model/IntegrationstrustCommerceTrustCommerceIntegration
 * @version v0.3
 */
export default class IntegrationstrustCommerceTrustCommerceIntegration {
  /**
   * Constructs a new <code>IntegrationstrustCommerceTrustCommerceIntegration</code>.
   * @alias module:model/IntegrationstrustCommerceTrustCommerceIntegration
   * @class
   * @param custid {String} 
   * @param password {String} 
   */
  constructor(custid, password) {
    this.custid = custid;
    this.password = password;
  }

  /**
   * Constructs a <code>IntegrationstrustCommerceTrustCommerceIntegration</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationstrustCommerceTrustCommerceIntegration} obj Optional instance to populate.
   * @return {module:model/IntegrationstrustCommerceTrustCommerceIntegration} The populated <code>IntegrationstrustCommerceTrustCommerceIntegration</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationstrustCommerceTrustCommerceIntegration();
      if (data.hasOwnProperty('custid'))
        obj.custid = ApiClient.convertToType(data['custid'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
      if (data.hasOwnProperty('transaction_license_key'))
        obj.transactionLicenseKey = ApiClient.convertToType(data['transaction_license_key'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} custid
 */
IntegrationstrustCommerceTrustCommerceIntegration.prototype.custid = undefined;

/**
 * @member {String} password
 */
IntegrationstrustCommerceTrustCommerceIntegration.prototype.password = undefined;

/**
 * @member {String} transactionLicenseKey
 */
IntegrationstrustCommerceTrustCommerceIntegration.prototype.transactionLicenseKey = undefined;

/**
 * @member {Boolean} enabled
 * @default true
 */
IntegrationstrustCommerceTrustCommerceIntegration.prototype.enabled = true;

